import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CheckCircle from '../check-circle';
import './see-price-head.css';

const SeePriceHead = forwardRef((props, ref) => {
  function seePriceHead() {
    return clsx('see-price-head', {
      ['see-price-head--default']: props.version === 'default',
      ['see-price-head--new-explicit']: props.version === 'new-explicit',
      ['see-price-head--new-short']: props.version === 'new-short',
    });
  }
  function seePriceHeadIcon() {
    return clsx('see-price-head__icon', {
      ['see-price-head__icon--default']: props.version === 'default',
      ['see-price-head__icon--new-explicit']: props.version === 'new-explicit',
      ['see-price-head__icon--new-short']: props.version === 'new-short',
    });
  }
  function seePriceHeadTitle() {
    return clsx('see-price-head__title', {
      ['see-price-head__title--default']: props.version === 'default',
      ['see-price-head__title--new-explicit']: props.version === 'new-explicit',
      ['see-price-head__title--new-short']: props.version === 'new-short',
    });
  }
  function seePriceHeadSubtitle() {
    return clsx('see-price-head__subtitle', {
      ['see-price-head__subtitle--default']: props.version === 'default',
      ['see-price-head__subtitle--new-explicit']: props.version === 'new-explicit',
      ['see-price-head__subtitle--new-short']: props.version === 'new-short',
    });
  }
  return (
    <div ref={ref} className={seePriceHead()}>
      {props.version === 'default' ? (
        <>
          <CheckCircle className={seePriceHeadIcon()} />
          <p className={seePriceHeadTitle()}>Sie sind rechtsschutzverischert</p>
          <p className={seePriceHeadSubtitle()}>
            Wir rechnen unsere Leistung direkt mit Ihrer Rechtsschutzversicherung ab.
          </p>
        </>
      ) : null}
      {props.version === 'new-explicit' ? (
        <>
          <CheckCircle className={seePriceHeadIcon()} />
          <p className={seePriceHeadTitle()}>Sie sind rechtsschutzverischert</p>
          <hr className='see-price-head__line' />
          <p className={seePriceHeadSubtitle()}>
            Wir rechnen unsere Leistung direkt mit Ihrer Rechtsschutzversicherung ab.
          </p>
        </>
      ) : null}
      {props.version === 'new-short' ? <p className={seePriceHeadTitle()}>Kosten für einen Einspruch</p> : null}
    </div>
  );
});

SeePriceHead.displayName = 'SeePriceHead';

SeePriceHead.propTypes = {
  version: PropTypes.oneOf(['default', 'new-explicit', 'new-short']),
};

export default SeePriceHead;
